// Module
var code = "<div class=\"iframe-container\">\r\n    <iframe src=\"{{.url}}\" name=\"iframe\" referrerpolicy=\"strict-origin-when-cross-origin\"></iframe>\r\n</div>";
// Exports
export default code;